/*
  Custom controller to extend and scale the 'react-jw-player' library for future updates.
*/

class JWPlayerController {
  constructor() {
    this.player = null;
    this.error = null;
  }

  setPlayer = player => {
    this.player = player;
  };

  setErrorHandler = setError => {
    this.setError = setError;
  };

  onError = ({ message }) => {
    this.error = message;
  };

  onSetupError = ({ message }) => {
    this.error = message;
  };

  onComplete = event => {};

  onPause = event => {};

  onPlay = event => {};

  get events() {
    return {
      play: this.onPlay,
      pause: this.onPause,
      error: this.onError,
      complete: this.onComplete,
      setupError: this.setupError
    };
  }
}

export default JWPlayerController;
